import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M516-481 346-651q-12-12-11-28t12-28q12-12 29-12t28 12l197 198q6 6 9 13 4 7 4 15t-4 15q-3 7-9 13L403-254q-12 12-28 11t-28-12q-12-12-12-28t12-29l169-169Z"/>',
  f: '<path d="M516-481 346-651q-12-12-11-28t12-28q12-12 29-12t28 12l197 198q6 6 9 13 4 7 4 15t-4 15q-3 7-9 13L403-254q-12 12-28 11t-28-12q-12-12-12-28t12-29l169-169Z"/>',
};

export default data;
